export default "__VITE_ASSET__DWYh9hJx__"